import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/hakkimizda', label: 'Hakkımızda' },
    { path: '/hizmetler', label: 'Hizmetler' },
    { path: '/islerimiz', label: 'İşlerimiz' },
    { path: '/blog', label: 'Blog' },
    { path: '/iletisim', label: 'İletişim' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/adenLogoYatay.png" alt="Logo" className="h-8 w-auto" />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.label.toLowerCase().replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c').replace(/ /g, '-')}`}
                className={`font-medium transition-colors ${isActive(link.path)
                  ? 'text-orange'
                  : 'text-slate-700 hover:text-orange'
                  }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/randevu"
              data-testid="nav-randevu-button"
              className="btn-secondary text-sm"
            >
              Randevu Al
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-navy"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div data-testid="mobile-menu" className="md:hidden bg-white border-t">
          <div className="px-6 py-4 space-y-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-link-${link.label.toLowerCase().replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c').replace(/ /g, '-')}`}
                onClick={() => setIsOpen(false)}
                className={`block py-2 font-medium ${isActive(link.path) ? 'text-orange' : 'text-slate-700'
                  }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/randevu"
              data-testid="mobile-nav-randevu-button"
              onClick={() => setIsOpen(false)}
              className="block btn-secondary text-center text-sm"
            >
              Randevu Al
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
